module.exports = __webpack_public_path__ + "static/media/View-2-.2539ade4.webp";